import type { Address, Feature } from '@ahm/api-wrappers-core';
import type { Store } from './ahafood';
import type { Tag } from './ahafood/get-deal-fn';
import type { OrderStore } from './use-get-store-order';

export const getAddressLabels = (address: string): string[] => {
  if (!address) return [''];
  const firstLabel = address.split(',')[0]!;

  const start = firstLabel.length;
  const length = address.length;

  const secondLabel = address?.substring(start, length).replace(',', '').trim();

  return [firstLabel, secondLabel];
};

export const formatFeatureToAddress = (feature: Feature): Address | null => {
  if (feature.properties) {
    const address = feature.properties.name;

    const [firstLabel, secondLabel] = getAddressLabels(address);

    const payload: Address = {
      address: feature.properties.name,
      description: feature?.properties?.name,
      short_address: feature.properties.name,
      place_id: feature.properties.place_id,
      adr_source: feature.properties.source || '',
      first_label: firstLabel,
      second_label: secondLabel,
    };

    if (feature.type) {
      payload.types = [feature.type];
    }

    if (feature.geometry?.coordinates) {
      payload.geometry = feature.geometry;

      payload.lat = feature.geometry.coordinates[1];
      payload.lng = feature.geometry.coordinates[0];
    }

    return payload;
  }

  return null;
};

export interface ProcessedDeal {
  tags: Tag[];
  title: string;
}

export function processDealData(deals: Tag[]): Record<string, ProcessedDeal> {
  const result: Record<string, ProcessedDeal> = {
    deal: { tags: [], title: '' },
  };

  deals.forEach((deal) => {
    let categorized = false;

    // Check if deal.screen exists and is an array before iterating
    if (deal.screen && Array.isArray(deal.screen)) {
      for (const screen of deal.screen) {
        const lowerScreen = screen.toLowerCase();
        if (lowerScreen.startsWith('banners')) {
          const key = lowerScreen.split(' ')[0];
          if (!result[key]) {
            result[key] = { tags: [], title: deal.color ?? '' };
          }
          result[key].tags.push(deal);
          categorized = true;
          break;
        }
      }
    }

    if (!categorized) {
      result.deal.tags.push(deal);
    }
  });

  return result;
}

export function convertStoreToOrderStore(store: Store): OrderStore | undefined {
  return {
    address: store.address,
    name: store.name,
    city_id: store.city_id,
    is_closed: store.is_closed,
    image_url: store.image_url,
    payment_methods: store.payment_methods,
    distance: store.distance,
    open_dates: store.open_dates,
    description: store.description,
    open_hours: store.open_hours,
    location: store.location,
    _id: store._id,
    tags: store.tags,
    promotion_info: store.promotion_info,
    page_id: store.page_id,
    menu_images: store.menu_images,
    slug: store.slug,
    branches: store.branches,
  };
}
